import { axiosInstance } from '@/lib/axios';
import type { AdminFeeConfig } from '@/types/api.types';

export const getAdminFeeConfig = async (): Promise<AdminFeeConfig> => {
  const response = await axiosInstance.get<AdminFeeConfig>('/settings/admin-fee-config');
  return response.data;
};

export const updateAdminFeeConfig = async (data: AdminFeeConfig): Promise<AdminFeeConfig> => {
  const response = await axiosInstance.put<AdminFeeConfig>('/settings/admin-fee-config', data);
  return response.data;
};
